import type { ListSchedule } from '../../../types/calendar';

export const schedules: ListSchedule[] = [
  // ============================================
  // OPTIMAL HEALTH & VITALITY ASPIRATION
  // ============================================

  // Cardiovascular Excellence Goal
  {
    id: 'schedule_list_strength',
    listId: 'list_strength',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday', 'wednesday', 'friday'],
      startDate: new Date('2024-09-05'),
      time: '06:00'
    },
    title: 'Full Body Strength Training',
    description: 'Progressive overload program focusing on all body parts',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_strength',
        type: 'push',
        minutesBefore: 30,
        message: 'Strength training in 30 minutes!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_zone_2',
    listId: 'list_zone_2',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      startDate: new Date('2024-09-05'),
      time: '12:00'
    },
    title: 'Zone 2 Cardio Training',
    description: 'Daily cardio for aerobic base building',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_zone_2',
        type: 'push',
        minutesBefore: 15,
        message: 'Zone 2 cardio time!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_zone_3',
    listId: 'list_zone_3',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['tuesday', 'thursday', 'saturday'],
      startDate: new Date('2024-09-05'),
      time: '07:00'
    },
    title: 'Zone 3 High Intensity Training',
    description: 'Structured Zone 3 training for VO2 max',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_zone_3',
        type: 'push',
        minutesBefore: 15,
        message: 'Zone 3 high intensity training!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_hiit',
    listId: 'list_hiit_sessions',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['saturday'],
      startDate: new Date('2024-09-05'),
      time: '08:00'
    },
    title: 'HIIT Sessions',
    description: 'High-intensity interval training',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_hiit',
        type: 'push',
        minutesBefore: 15,
        message: 'HIIT session starting soon!',
        isEnabled: true
      }
    ]
  },

  // Functional Strength Goal
  {
    id: 'schedule_list_upper_body',
    listId: 'list_upper_body',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['tuesday', 'friday'],
      startDate: new Date('2024-09-05'),
      time: '06:30'
    },
    title: 'Upper Body Focus',
    description: 'Upper body strength training sessions',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_upper_body',
        type: 'push',
        minutesBefore: 15,
        message: 'Upper body workout time!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_lower_body',
    listId: 'list_lower_body',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday', 'thursday'],
      startDate: new Date('2024-09-05'),
      time: '06:30'
    },
    title: 'Lower Body Focus',
    description: 'Lower body strength training sessions',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_lower_body',
        type: 'push',
        minutesBefore: 15,
        message: 'Leg day!',
        isEnabled: true
      }
    ]
  },

  // Nutrition & Recovery Goal
  {
    id: 'schedule_list_meal_prep',
    listId: 'list_meal_prep',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['sunday'],
      startDate: new Date('2024-09-05'),
      time: '10:00'
    },
    title: 'Weekly Meal Prep',
    description: 'Sunday meal preparation for the week',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_meal_prep',
        type: 'push',
        minutesBefore: 60,
        message: 'Meal prep in 1 hour!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_sleep_routine',
    listId: 'list_sleep_routine',
    type: 'daily',
    recurringPattern: {
      dailyInterval: 1,
      startDate: new Date('2024-09-05'),
      time: '21:00'
    },
    title: 'Sleep Optimization Routine',
    description: 'Evening routine for quality sleep',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_sleep_routine',
        type: 'push',
        minutesBefore: 0,
        message: 'Time for your sleep routine!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_supplements_morning',
    listId: 'list_supplements',
    type: 'daily',
    recurringPattern: {
      dailyInterval: 1,
      startDate: new Date('2024-09-05'),
      time: '07:30'
    },
    title: 'Morning Supplements',
    description: 'Take morning supplements (Creatine, Vitamin D)',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_supplements_morning',
        type: 'push',
        minutesBefore: 0,
        message: 'Take your morning supplements!',
        isEnabled: true
      }
    ]
  },
  // SECOND SCHEDULE FOR SAME LIST - Testing duplicate schedules on same day
  {
    id: 'schedule_list_supplements_evening',
    listId: 'list_supplements',
    type: 'daily',
    recurringPattern: {
      dailyInterval: 1,
      startDate: new Date('2024-09-05'),
      time: '21:30'
    },
    title: 'Evening Supplements',
    description: 'Take evening supplements (Magnesium, Fish Oil)',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_supplements_evening',
        type: 'push',
        minutesBefore: 0,
        message: 'Take your evening supplements!',
        isEnabled: true
      }
    ]
  },

  // ============================================
  // FINANCIAL INDEPENDENCE ASPIRATION
  // ============================================

  // Passive Income Goal
  {
    id: 'schedule_list_financial_review',
    listId: 'list_financial_independence',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['friday'],
      startDate: new Date('2024-09-05'),
      time: '17:00'
    },
    title: 'Weekly Financial Review',
    description: 'Review budget and financial progress',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_financial_review',
        type: 'push',
        minutesBefore: 30,
        message: 'Financial review in 30 minutes',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_dividend_portfolio',
    listId: 'list_dividend_portfolio',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      dayOfMonth: 1,
      startDate: new Date('2024-09-01'),
      time: '09:00'
    },
    title: 'Monthly Portfolio Review',
    description: 'Review dividend portfolio performance',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_dividend_portfolio',
        type: 'push',
        minutesBefore: 60,
        message: 'Monthly portfolio review today!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_digital_products',
    listId: 'list_digital_products',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['saturday', 'sunday'],
      startDate: new Date('2024-09-05'),
      time: '14:00'
    },
    title: 'Digital Product Work',
    description: 'Work on digital product creation',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_digital_products',
        type: 'push',
        minutesBefore: 15,
        message: 'Time for digital product work!',
        isEnabled: true
      }
    ]
  },

  // Emergency Fund Goal
  {
    id: 'schedule_list_budget_optimization',
    listId: 'list_budget_optimization',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      dayOfMonth: 15,
      startDate: new Date('2024-09-15'),
      time: '10:00'
    },
    title: 'Mid-Month Budget Check',
    description: 'Review and optimize monthly budget',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_budget_optimization',
        type: 'push',
        minutesBefore: 60,
        message: 'Budget check today!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_savings_automation',
    listId: 'list_savings_automation',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      dayOfMonth: 1,
      startDate: new Date('2024-09-01'),
      time: '08:00'
    },
    title: 'Monthly Savings Transfer',
    description: 'Verify automatic savings transfer completed',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_savings_automation',
        type: 'push',
        minutesBefore: 0,
        message: 'Check savings transfer!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_income_boost',
    listId: 'list_income_boost',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['wednesday'],
      startDate: new Date('2024-09-05'),
      time: '19:00'
    },
    title: 'Side Income Strategy',
    description: 'Work on income boost strategies',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_income_boost',
        type: 'push',
        minutesBefore: 30,
        message: 'Side income work session',
        isEnabled: true
      }
    ]
  },

  // Side Income Goal
  {
    id: 'schedule_list_saas_mvp',
    listId: 'list_saas_mvp',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['tuesday', 'thursday', 'saturday'],
      startDate: new Date('2024-09-05'),
      time: '19:00'
    },
    title: 'SaaS Development Session',
    description: 'Work on SaaS MVP development',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_saas_mvp',
        type: 'push',
        minutesBefore: 15,
        message: 'SaaS dev session starting!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_saas_marketing',
    listId: 'list_saas_marketing',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['sunday'],
      startDate: new Date('2024-09-05'),
      time: '16:00'
    },
    title: 'Marketing & Content',
    description: 'Work on SaaS marketing content',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_saas_marketing',
        type: 'push',
        minutesBefore: 15,
        message: 'Marketing work session!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_saas_operations',
    listId: 'list_saas_operations',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      weekOfMonth: 1,
      dayOfWeekInMonth: 'monday',
      startDate: new Date('2024-09-01'),
      time: '10:00'
    },
    title: 'SaaS Operations Review',
    description: 'Review business operations and legal',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_saas_operations',
        type: 'push',
        minutesBefore: 60,
        message: 'Operations review today!',
        isEnabled: true
      }
    ]
  },

  // ============================================
  // STRONG RELATIONSHIPS ASPIRATION
  // ============================================

  // Family Time Goal
  {
    id: 'schedule_list_morning_routine',
    listId: 'list_today_routine',
    type: 'daily',
    recurringPattern: {
      dailyInterval: 1,
      startDate: new Date('2024-09-05'),
      time: '06:00'
    },
    title: 'Morning Routine',
    description: 'Daily morning routine',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_morning_routine',
        type: 'push',
        minutesBefore: 0,
        message: 'Good morning! Start your routine.',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_family_dinners',
    listId: 'list_family_dinners',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['sunday'],
      startDate: new Date('2024-09-05'),
      time: '17:00'
    },
    title: 'Family Dinner Prep',
    description: 'Prepare and enjoy family dinner',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_family_dinners',
        type: 'push',
        minutesBefore: 60,
        message: 'Family dinner prep time!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_family_adventures',
    listId: 'list_family_adventures',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      weekOfMonth: 2,
      dayOfWeekInMonth: 'saturday',
      startDate: new Date('2024-09-01'),
      time: '09:00'
    },
    title: 'Monthly Family Adventure',
    description: 'Special family activity day',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_family_adventures',
        type: 'push',
        minutesBefore: 720,
        message: 'Family adventure tomorrow! Get ready.',
        isEnabled: true
      }
    ]
  },

  // Friend Connections Goal
  {
    id: 'schedule_list_friend_checkins',
    listId: 'list_friend_checkins',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['wednesday', 'saturday'],
      startDate: new Date('2024-09-05'),
      time: '18:00'
    },
    title: 'Friend Check-ins',
    description: 'Call or message friends',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_friend_checkins',
        type: 'push',
        minutesBefore: 15,
        message: 'Time to catch up with friends!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_friend_activities',
    listId: 'list_friend_activities',
    type: 'monthly',
    recurringPattern: {
      monthlyInterval: 1,
      weekOfMonth: 3,
      dayOfWeekInMonth: 'saturday',
      startDate: new Date('2024-09-01'),
      time: '14:00'
    },
    title: 'Friend Group Activity',
    description: 'Monthly friend group activity',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_friend_activities',
        type: 'push',
        minutesBefore: 120,
        message: 'Friend activity in 2 hours!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_new_connections',
    listId: 'list_new_connections',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['thursday'],
      startDate: new Date('2024-09-05'),
      time: '19:00'
    },
    title: 'Network & Connect',
    description: 'Attend meetups or social events',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_new_connections',
        type: 'push',
        minutesBefore: 60,
        message: 'Networking event tonight!',
        isEnabled: true
      }
    ]
  },

  // Portfolio Goal
  {
    id: 'schedule_list_photo_portfolio',
    listId: 'list_photo_portfolio',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['saturday', 'sunday'],
      startDate: new Date('2024-09-05'),
      time: '07:00'
    },
    title: 'Photography Session',
    description: 'Golden hour photography',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_photo_portfolio',
        type: 'push',
        minutesBefore: 30,
        message: 'Photography session - golden hour!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_design_portfolio',
    listId: 'list_design_portfolio',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['sunday'],
      startDate: new Date('2024-09-05'),
      time: '13:00'
    },
    title: 'Design Work',
    description: 'UI/UX and graphic design projects',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_design_portfolio',
        type: 'push',
        minutesBefore: 15,
        message: 'Design work session!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_portfolio_marketing',
    listId: 'list_portfolio_marketing',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['friday'],
      startDate: new Date('2024-09-05'),
      time: '18:00'
    },
    title: 'Portfolio Promotion',
    description: 'Share and promote creative work',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_portfolio_marketing',
        type: 'push',
        minutesBefore: 15,
        message: 'Portfolio promotion time!',
        isEnabled: true
      }
    ]
  },

  // ============================================
  // STRONG BODY ASPIRATION
  // ============================================

  // Strength Training Goal
  {
    id: 'schedule_list_strength_training_morning',
    listId: 'list_strength_training',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday', 'wednesday', 'friday'],
      startDate: new Date('2024-09-05'),
      time: '05:30'
    },
    title: 'Morning Strength Training',
    description: 'Foundation phase strength work',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_strength_training_morning',
        type: 'push',
        minutesBefore: 30,
        message: 'Morning strength training!',
        isEnabled: true
      }
    ]
  },
  // SECOND SCHEDULE FOR SAME LIST - Testing duplicate schedules
  {
    id: 'schedule_list_strength_training_evening',
    listId: 'list_strength_training',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday'],
      startDate: new Date('2024-09-05'),
      time: '18:00'
    },
    title: 'Evening Strength Training (Recovery)',
    description: 'Light mobility and recovery work',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_strength_training_evening',
        type: 'push',
        minutesBefore: 15,
        message: 'Evening recovery session!',
        isEnabled: true
      }
    ]
  },

  // Muscle Definition Goal
  {
    id: 'schedule_list_nutrition_optimization',
    listId: 'list_definition_1',
    type: 'daily',
    recurringPattern: {
      dailyInterval: 1,
      startDate: new Date('2024-09-05'),
      time: '08:00'
    },
    title: 'Morning Nutrition Check',
    description: 'Track macros and plan meals',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_nutrition_optimization',
        type: 'push',
        minutesBefore: 0,
        message: 'Log your breakfast!',
        isEnabled: true
      }
    ]
  },
  {
    id: 'schedule_list_body_fat_reduction',
    listId: 'list_definition_2',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['sunday'],
      startDate: new Date('2024-09-05'),
      time: '08:00'
    },
    title: 'Weekly Progress Check',
    description: 'Weigh-in and progress photos',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_body_fat_reduction',
        type: 'push',
        minutesBefore: 0,
        message: 'Weekly weigh-in time!',
        isEnabled: true
      }
    ]
  },

  // Deep Learning Goal
  {
    id: 'schedule_list_deep_learning_weekday',
    listId: 'list_deep_learning',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
      startDate: new Date('2024-09-05'),
      time: '20:00'
    },
    title: 'Deep Learning Study',
    description: 'Evening study session',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_deep_learning_weekday',
        type: 'push',
        minutesBefore: 15,
        message: 'Deep learning study time!',
        isEnabled: true
      }
    ]
  },
  // THIRD SCHEDULE FOR SAME LIST - Weekend extended study
  {
    id: 'schedule_list_deep_learning_weekend',
    listId: 'list_deep_learning',
    type: 'weekly',
    recurringPattern: {
      weeklyInterval: 1,
      daysOfWeek: ['saturday'],
      startDate: new Date('2024-09-05'),
      time: '10:00'
    },
    title: 'Deep Learning Extended Session',
    description: 'Weekend extended study session',
    isActive: true,
    createdAt: new Date('2024-09-05'),
    updatedAt: new Date('2024-09-05'),
    notifications: [
      {
        id: 'notif_list_deep_learning_weekend',
        type: 'push',
        minutesBefore: 30,
        message: 'Extended study session!',
        isEnabled: true
      }
    ]
  }
];
